export default __webpack_public_path__ + "static/media/LogoBrand.bb0bb729.svg";